import { translate, localHref } from "../i18n";
import LanguageSwitcher from "../components/LanguageSwitcher";
import SiteFooter from "../components/SiteFooter";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Check } from "@phosphor-icons/react";
import { PRODUCTS } from "../content/products";
const CATEGORY_COPY = {
  [translate("Azienda")]: {
    lead: translate("Uno strumento di lavoro pensato intorno alla tua identit\xE0."),
    intro: translate("Definiamo formato, quantit\xE0 e materiali in base all\u2019uso reale, mantenendo grafica e finiture coerenti con tutti gli altri stampati aziendali."),
    benefits: [translate("Formato e impostazione su misura"), translate("Piccole e medie tirature"), translate("Grafica coordinata al marchio"), translate("Controllo professionale dei file")],
    materials: [translate("Carte naturali e patinate"), translate("Carte riciclate e speciali"), translate("Plastificazioni e vernici"), translate("Fustelle e lavorazioni dedicate")]
  },
  [translate("Editoria")]: {
    lead: translate("Pagine, immagini e contenuti costruiti per essere sfogliati."),
    intro: translate("Dalla scelta del formato alla rilegatura, valutiamo insieme carta, numero di pagine e finiture per ottenere un prodotto piacevole da leggere e durevole."),
    benefits: [translate("Controllo di pagine e abbondanze"), translate("Prove colore su richiesta"), translate("Tirature digitali flessibili"), translate("Rilegatura adatta al progetto")],
    materials: [translate("Carte naturali o patinate"), translate("Copertine rigide o flessibili"), translate("Punto metallico e spirale"), translate("Brossura fresata o cucita")]
  },
  [translate("Etichette")]: {
    lead: translate("Il tuo marchio nella forma e sul supporto pi\xF9 adatti."),
    intro: translate("Partiamo dalla superficie, dall\u2019ambiente d\u2019uso e dal metodo di applicazione per scegliere adesivo, materiale e protezione corretti."),
    benefits: [translate("Sagomatura personalizzata"), translate("Dati e numerazioni variabili"), translate("Piccole e grandi quantit\xE0"), translate("Soluzioni per interno ed esterno")],
    materials: [translate("Carta adesiva"), translate("PVC bianco o trasparente"), translate("Supporti resistenti ad acqua e UV"), translate("Finiture opache o lucide")]
  },
  [translate("Grande formato")]: {
    lead: translate("Una comunicazione progettata per farsi vedere nello spazio."),
    intro: translate("Dimensioni, distanza di lettura, supporto e durata vengono valutati insieme per realizzare una soluzione efficace e pratica da installare."),
    benefits: [translate("Formati personalizzati"), translate("Controllo della risoluzione"), translate("Supporti per interno ed esterno"), translate("Finiture pronte per il montaggio")],
    materials: [translate("Pannelli rigidi"), translate("Teli e banner"), translate("Carte per affissione"), translate("Film adesivi e laminazioni")]
  },
  [translate("Ristorazione")]: {
    lead: translate("Un supporto bello da vedere e pratico da usare ogni giorno."),
    intro: translate("Scegliamo formato, materiale e protezione considerando pulizia, frequenza d\u2019uso e stile del locale, senza perdere leggibilit\xE0."),
    benefits: [translate("Formati adatti al servizio"), translate("Grafica coordinata al locale"), translate("Aggiornamenti e ristampe flessibili"), translate("Materiali facili da gestire")],
    materials: [translate("Carte naturali e patinate"), translate("Supporti sintetici lavabili"), translate("Plastificazioni protettive"), translate("Pieghe e rilegature")]
  },
  [translate("Eventi e regali")]: {
    lead: translate("Un prodotto personalizzato che continua a parlare di te."),
    intro: translate("Costruiamo una proposta coerente con occasione, destinatari, quantit\xE0 e tempi di consegna, valorizzando il marchio senza renderlo invasivo."),
    benefits: [translate("Personalizzazione coordinata"), translate("Quantit\xE0 flessibili"), translate("Confezionamento su richiesta"), translate("Pianificazione delle scadenze")],
    materials: [translate("Carte e cartoncini selezionati"), translate("Supporti rigidi o flessibili"), translate("Stampa a colori e dati variabili"), translate("Finiture speciali")]
  }
};
function ProductImage({
  product,
  decorative = false
}) {
  if (product.sheet) return <div className="sp-catalog-sprite" role={decorative ? undefined : "img"} aria-label={decorative ? undefined : translate("{0} personalizzato Pedrazzini", {
    0: product.title
  })} style={{
    backgroundImage: `url(/images/products/${product.sheet}-collection.webp)`,
    backgroundPosition: `${product.cell % 3 * 50}% ${Math.floor(product.cell / 3) * 100}%`
  }} />;
  return <img src={`/images/products/${product.id}.webp`} alt={decorative ? "" : translate("{0} personalizzato da Pedrazzini Print 365", {
    0: product.title
  })} />;
}
export default function CatalogProductPage() {
  const {
    id
  } = useParams();
  const product = PRODUCTS.find(item => item.id === id);
  const copy = product ? CATEGORY_COPY[product.category] : null;
  const related = product ? PRODUCTS.filter(item => item.id !== product.id && item.category === product.category).slice(0, 3) : [];
  if (!product) return <main className="sp-not-found">
        <h1>{translate("Prodotto non trovato")}</h1>
        <Link to="/#prodotti">{translate("Torna ai prodotti")}</Link>
      </main>;
  const quote = `/?prodotto=${encodeURIComponent(product.title)}#contatti`;
  return <div className="sp">
      <header className="sp-header">
        <div className="sp-wrap">
          <Link to="/" className="sp-logo">
            <img src="/images/pedrazzini-print365-640.webp" alt="Pedrazzini Print 365" />
          </Link>
          <nav>
            <Link to="/#prodotti">{translate("Prodotti")}</Link>
            <Link to="/#servizi">{translate("La stampa")}</Link>
            <Link to="/proposte/natale-2026/">{translate("Questo mese")}</Link>
            <a className="sp-header-cta" href={localHref(quote)}>{translate("Preventivo ")}<ArrowUpRight size={20} />
            </a>
          </nav><LanguageSwitcher />
        </div>
      </header>
      <main>
        <section className="sp-hero">
          <div className="sp-wrap sp-hero-grid">
            <div>
              <Link className="sp-back" to="/#prodotti">
                <ArrowLeft />{translate(" Tutti i prodotti")}</Link>
              <p className="sp-kicker">{product.category} · LOCARNO</p>
              <h1>{product.title}</h1>
              <p className="sp-lead">{copy.lead}</p>
              <a className="sp-button" href={localHref(quote)}>{translate("Richiedi un preventivo ")}<ArrowUpRight size={24} />
              </a>
            </div>
            <div className="sp-hero-image sp-catalog-image">
              <ProductImage product={product} />
              <span>{translate("PREVENTIVO")}<br />
                <strong>{translate("ENTRO 24 ORE")}</strong>
              </span>
            </div>
          </div>
        </section>
        <section className="sp-intro">
          <div className="sp-wrap sp-two">
            <p className="sp-kicker">{translate("PENSATO PER IL TUO UTILIZZO")}</p>
            <div>
              <h2>
                {product.title},<br />{translate("fatto come serve a te.")}</h2>
              <p>
                <strong>{product.description}</strong> {copy.intro}
              </p>
            </div>
          </div>
        </section>
        <section className="sp-specs">
          <div className="sp-wrap sp-spec-grid">
            <div>
              <p className="sp-kicker">{translate("DAL FILE AL PRODOTTO FINITO")}</p>
              <h2>{translate("Ogni dettaglio")}<br />{translate("ha una funzione.")}</h2>
              <ul>
                {copy.benefits.map(item => <li key={item}>
                    <Check size={22} />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="sp-material">
              <p className="sp-kicker">{translate("MATERIALI E FINITURE")}</p>
              {copy.materials.map((item, index) => <div key={item}>
                  <span>0{index + 1}</span>
                  <strong>{item}</strong>
                </div>)}
            </div>
          </div>
        </section>
        {related.length > 0 && <section className="sp-recommended">
            <div className="sp-wrap">
              <p className="sp-kicker">{translate("DA ABBINARE")}</p>
              <h2>{translate("Altri prodotti")}<br />{translate("della stessa famiglia.")}</h2>
              <div className="sp-recommended-grid">
                {related.map(item => <Link to={`/catalogo/${item.id}/`} key={item.id}>
                    <ProductImage product={item} decorative />
                    <div>
                      <span>{item.category}</span>
                      <strong>{item.title}</strong>
                      <p>{item.description}</p>
                      <b>{translate("Scopri il prodotto ")}<ArrowUpRight size={20} />
                      </b>
                    </div>
                  </Link>)}
              </div>
            </div>
          </section>}
        <section className="sp-faq">
          <div className="sp-wrap">
            <p className="sp-kicker">{translate("PRIMA DI STAMPARE")}</p>
            <h2>{translate("Le informazioni che ci aiutano.")}</h2>
            <div className="sp-faq-grid">
              <article>
                <h3>{translate("Quale quantit\xE0 ti serve?")}</h3>
                <p>{translate("Indica il numero di pezzi e l\u2019eventuale necessit\xE0 di versioni differenti. Ti proponiamo il sistema di stampa pi\xF9 adatto evitando quantit\xE0 inutili.")}</p>
              </article>
              <article>
                <h3>{translate("Hai gi\xE0 il file grafico?")}</h3>
                <p>{translate("Possiamo controllarlo prima della produzione. Se il progetto deve ancora essere preparato, raccontaci contenuti, formato e risultato desiderato.")}</p>
              </article>
            </div>
          </div>
        </section>
        <section className="sp-contact">
          <div className="sp-wrap sp-contact-grid">
            <div>
              <p className="sp-kicker">{translate("PARLIAMONE")}</p>
              <h2>{translate("Vuoi realizzare")}<br />
                <span>{product.title.toLowerCase()}?</span>
              </h2>
            </div>
            <div>
              <p>{translate("Scrivici quantit\xE0, formato, utilizzo e data desiderata. Riceverai un preventivo personalizzato entro 24 ore.")}</p>
              <a className="sp-button" href={localHref(quote)}>{translate("Chiedi il preventivo ")}<ArrowUpRight size={24} />
              </a>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>;
}
